import { OurTeam } from "./OurTeam";
import type { OurTeamProps } from "./OurTeam.d";

export { OurTeam, OurTeamProps };
